module.exports = __webpack_public_path__ + "static/media/misk.71867ef1.png";